<div class="orgbrain-style" style="min-width: 250px">
  <orgbrain-dialog-title [title]="data.title" (closeClick)="dialogRef.close(true)">
  </orgbrain-dialog-title>

  <div class="d-flex justify-between flex-col">
    <p [innerHtml]="trustedHtml" class="mat-body"></p>
    <mat-dialog-actions align="end" class="mb-pixel-0 pb-pixel-0 !pt-8">
      <button
        mat-flat-button
        color="primary"
        class="action-button"
        cdkFocusInitial
        (click)="dialogRef.close(true)"
        id="_iformdialog_OK-button"
      >
        OK
      </button>
    </mat-dialog-actions>
  </div>
</div>
